import React from "react";

const Footer = () => {
  return (
    <>
      {/* Contact Section */}
      <section id="contact" className="py-5 bg-dark text-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <h2 className="display-5 fw-bold mb-4">Ready to Get Started?</h2>
              <p className="lead mb-4">
                Join thousands of satisfied customers who trust ServerPro for
                their hosting needs.
              </p>
              <div className="row g-3 justify-content-center">
                <div className="col-md-4">
                  <input
                    type="email"
                    className="form-control form-control-lg"
                    placeholder="Enter your email"
                  />
                </div>
                <div className="col-md-3">
                  <button className="btn btn-primary btn-lg w-100">
                    Start Free Trial
                  </button>
                </div>
              </div>
              <p className="small text-muted mt-3">
                No credit card required. 30-day money-back guarantee.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-5">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-4">
              <h5 className="fw-bold mb-3">
                <i className="fas fa-server me-2"></i>
                ServerPro
              </h5>
              <p className="text-muted">
                Premium server solutions trusted by businesses worldwide. Fast,
                secure, and reliable hosting services.
              </p>
              <div className="d-flex gap-3">
                <a href="#" className="text-white">
                  <i className="fab fa-facebook fa-lg"></i>
                </a>
                <a href="#" className="text-white">
                  <i className="fab fa-twitter fa-lg"></i>
                </a>
                <a href="#" className="text-white">
                  <i className="fab fa-linkedin fa-lg"></i>
                </a>
                <a href="#" className="text-white">
                  <i className="fab fa-github fa-lg"></i>
                </a>
              </div>
            </div>

            <div className="col-lg-2 col-md-6">
              <h6 className="fw-bold mb-3">Services</h6>
              <ul className="list-unstyled">
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    Web Hosting
                  </a>
                </li>
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    VPS Hosting
                  </a>
                </li>
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    Dedicated Servers
                  </a>
                </li>
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    Cloud Hosting
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-lg-2 col-md-6">
              <h6 className="fw-bold mb-3">Support</h6>
              <ul className="list-unstyled">
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    Help Center
                  </a>
                </li>
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    Documentation
                  </a>
                </li>
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    Contact Us
                  </a>
                </li>
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    Status Page
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-lg-2 col-md-6">
              <h6 className="fw-bold mb-3">Company</h6>
              <ul className="list-unstyled">
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    Careers
                  </a>
                </li>
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    Blog
                  </a>
                </li>
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    Partners
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-lg-2 col-md-6">
              <h6 className="fw-bold mb-3">Legal</h6>
              <ul className="list-unstyled">
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    Cookie Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="text-muted text-decoration-none">
                    GDPR
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <hr className="my-4" />

          <div className="row align-items-center">
            <div className="col-md-6">
              <p className="text-muted mb-0">
                © 2024 ServerPro. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-md-end">
              <p className="text-muted mb-0">
                Made with <i className="fas fa-heart text-danger"></i> for
                developers
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
